import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useMemo } from 'modules/core/hooks/useMemo'
import Constant from 'modules/core/store/models/Constant'

interface Props {
  redirectIfFailRoute: string
  stripeAccount?: string
}

const StripeWrapper = ({
  children,
  redirectIfFailRoute,
  stripeAccount,
}: React.PropsWithChildren<Props>) => {
  const [stripeKey, setStripeKey] = React.useState<string | null | undefined>(null)
  const navigate = useNavigate()

  const { loading } = useAsyncData(async () => {
    const stripeKeyConstant = new Constant({
      id: 'public_stripe_api_key',
    })

    const result = await stripeKeyConstant.fetch()

    if (result.value) {
      setStripeKey(result.value)
    } else {
      navigate(redirectIfFailRoute)
    }
  }, [])

  const stripePromise = useMemo(() => {
    if (!stripeKey) return null

    return loadStripe(stripeKey, {
      betas: ['issuing_elements_2'],
      stripeAccount,
      apiVersion: '2020-08-27',
    })
  }, [stripeKey, stripeAccount])

  if (loading || !stripeKey) return null

  return <Elements stripe={stripePromise}>{children}</Elements>
}

export default observer(StripeWrapper)
